// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.manual-asset-page {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 1rem;
  color: var(--ca-text-primary, #172033);
}

.page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  margin: 0.25rem 0 1.25rem;
}

.heading-copy {
  min-width: 0;
}

.heading-copy h1 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.4rem, 2.2vw, 1.85rem);
  font-weight: 750;
  letter-spacing: -0.035em;
}

.eyebrow {
  margin-bottom: 0.45rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.heading-copy > p {
  max-width: 760px;
  margin: 0.55rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.6;
}

.heading-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  flex: 0 0 auto;
}

.heading-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.25rem;
  height: 3.25rem;
  color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  border: 1px solid rgba(40, 80, 173, 0.15);
  border-radius: var(--ca-radius-lg, 12px);
  font-size: 1.35rem;
}

.dialog-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  padding: 0;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-sm, 6px);
  background: var(--ca-surface, #fff);
  color: var(--ca-text-secondary, #4b5870);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.dialog-close:hover:not(:disabled) {
  border-color: var(--ca-border, #dfe4ec);
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-primary, #172033);
}
.dialog-close:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 3px;
}
.dialog-close:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.manual-asset-card {
  overflow: hidden;
  background: var(--ca-surface, #fff);
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));
}

.card-intro {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 1.15rem clamp(1.1rem, 2.5vw, 2rem);
  background: linear-gradient(180deg, #fbfcff 0%, #f7f9fd 100%);
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.card-intro-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.7rem;
  height: 2.7rem;
  flex: 0 0 2.7rem;
  color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  border-radius: var(--ca-radius-md, 8px);
  font-size: 1.1rem;
}

.card-intro-copy {
  min-width: 0;
}

.card-intro h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.05rem;
  font-weight: 750;
}

.card-intro p {
  margin: 0.25rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
  line-height: 1.5;
}

.asset-id-reference {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  max-width: 100%;
  margin-top: 0.45rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.72rem;
  overflow-wrap: anywhere;
}

.required-note {
  margin-left: auto;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.75rem;
  white-space: nowrap;
}

.required-mark {
  color: var(--ca-danger, #dc3545);
  font-weight: 800;
}

.form-section {
  padding: clamp(1.1rem, 2.4vw, 1.8rem);
}

.form-section + .form-section {
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.section-heading {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  margin-bottom: 1.25rem;
}

.section-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  border-radius: 0.55rem;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.section-heading h3 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1rem;
  font-weight: 750;
}

.section-heading p {
  margin: 0.25rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
  line-height: 1.5;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.15rem 1.5rem;
}

.field-group {
  min-width: 0;
}

.field-full {
  grid-column: 1/-1;
}

.field-group .form-label {
  display: block;
  margin-bottom: 0.45rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
  font-weight: 650;
}

.form-control,
.form-select {
  min-height: 42px;
  border-color: var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-sm, 6px);
  color: var(--ca-text-primary, #172033);
  font-size: 0.875rem;
  box-shadow: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.form-control:hover:not(:disabled):not([readonly]),
.form-select:hover:not(:disabled):not([readonly]) {
  border-color: var(--ca-border-dark, #c7cfdd);
}

.form-control:focus,
.form-select:focus {
  border-color: var(--ca-primary-light, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.13);
}

.form-control.is-invalid,
.form-select.is-invalid {
  border-color: var(--ca-danger, #dc3545);
  background-image: none;
}

.description-input {
  min-height: 100px;
  resize: vertical;
}

.monospace-input {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 0.8rem;
}

.field-hint {
  display: block;
  margin-top: 0.35rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  line-height: 1.45;
}

.field-error {
  display: block;
  margin-top: 0.35rem;
  color: var(--ca-danger, #dc3545);
  font-size: 0.74rem;
  line-height: 1.4;
}

.optional-label {
  margin-left: 0.4rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  font-weight: 500;
}

.form-error-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  margin: 0 clamp(1.1rem, 2.4vw, 1.8rem) 1rem;
  padding: 0.85rem 1rem;
  color: #842029;
  background: var(--ca-danger-bg, #fdecef);
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.82rem;
  line-height: 1.45;
}
.form-error-banner i {
  margin-top: 0.1rem;
  flex: 0 0 auto;
}

.form-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem clamp(1.1rem, 2.4vw, 1.8rem);
  background: #fbfcfe;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.form-actions-note {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.75rem;
  line-height: 1.4;
}
.form-actions-note i {
  flex: 0 0 auto;
  color: var(--ca-success, #198754);
  font-size: 1rem;
}

.action-buttons,
.load-failure-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.7rem;
  flex-shrink: 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0.55rem 1rem;
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.82rem;
  font-weight: 650;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.btn-cancel {
  color: var(--ca-text-secondary, #4b5870);
  background: #fff;
  border: 1px solid var(--ca-border, #dfe4ec);
}
.btn-cancel:hover:not(:disabled) {
  color: var(--ca-text-primary, #172033);
  background: var(--ca-bg-secondary, #eef2f8);
  border-color: var(--ca-border-dark, #c7cfdd);
}

.btn-save {
  color: #fff;
  background: var(--ca-primary, #0e2e80);
  border: 1px solid var(--ca-primary, #0e2e80);
  box-shadow: 0 2px 5px rgba(14, 46, 128, 0.12);
}
.btn-save:hover:not(:disabled) {
  color: #fff;
  background: var(--ca-primary-dark, #0d2863);
  border-color: var(--ca-primary-dark, #0d2863);
}
.btn-save:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 3px;
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.loading-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 280px;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.875rem;
}

.load-failure {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  padding: 2rem 1.25rem;
  text-align: center;
}
.load-failure h3 {
  margin: 0.8rem 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1rem;
  font-weight: 750;
}
.load-failure p {
  max-width: 34rem;
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.84rem;
  line-height: 1.55;
}

.load-failure-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
  font-size: 1.25rem;
}

.load-failure-actions {
  margin-top: 1.25rem;
}

@media (max-width: 767.98px) {
  .heading-mark {
    width: 2.8rem;
    height: 2.8rem;
    font-size: 1.1rem;
  }
  .card-intro {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .required-note {
    width: 100%;
    margin-left: 3.6rem;
  }
  .form-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 1.05rem;
  }
  .field-full {
    grid-column: auto;
  }
  .form-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .action-buttons {
    justify-content: flex-end;
  }
}
@media (max-width: 480px) {
  .manual-asset-page {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .heading-mark {
    display: none;
  }
  .heading-actions {
    gap: 0.25rem;
  }
  .card-intro {
    gap: 0.7rem;
    padding: 1rem;
  }
  .form-section {
    padding: 1.1rem 1rem;
  }
  .form-actions {
    padding: 1rem;
  }
  .form-error-banner {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .action-buttons {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
  }
  .action-buttons .btn {
    width: 100%;
    padding-right: 0.6rem;
    padding-left: 0.6rem;
  }
  .form-actions-note {
    font-size: 0.7rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .dialog-close,
  .form-control,
  .form-select,
  .btn {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/asset-management/assets-view/data-asset-manual-update/data-asset-manual-update.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iDAAA;EACA,sCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,SAAA;EACA,sCAAA;EACA,wCAAA;EACA,gBAAA;EACA,wBAAA;AACF;;AAEA;EACE,sBAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;EACA,6CAAA;EACA,yCAAA;EACA,wCAAA;EACA,kBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,iDAAA;EACA,uCAAA;EACA,mCAAA;EACA,wCAAA;EACA,eAAA;EACA,kFAAA;AACF;AACE;EACE,uCAAA;EACA,2CAAA;EACA,sCAAA;AACJ;AAEE;EACE,mDAAA;EACA,mBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,YAAA;AADJ;;AAKA;EACE,gBAAA;EACA,mCAAA;EACA,iDAAA;EACA,wCAAA;EACA,iEAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,2CAAA;EACA,6DAAA;EACA,wDAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,iCAAA;EACA,6CAAA;EACA,uCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,uCAAA;EACA,kBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,qCAAA;AAFF;;AAKA;EACE,qDAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EACA,6CAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,SAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,gDAAA;EACA,mBAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,sBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;;EAEE,gBAAA;EACA,6CAAA;EACA,uCAAA;EACA,sCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uFAAA;AAFF;;AAKA;;EAEE,4CAAA;AAFF;;AAKA;;EAEE,8CAAA;EACA,gDAAA;AAFF;;AAKA;;EAEE,uCAAA;EACA,sBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gGAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,2CAAA;EACA,qBAAA;EACA,cAAA;EACA,wCAAA;EACA,2CAAA;EACA,uCAAA;EACA,kBAAA;EACA,iBAAA;AAFF;AAIE;EACE,kBAAA;EACA,cAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,4CAAA;EACA,mBAAA;EACA,qDAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AAHF;AAKE;EACE,cAAA;EACA,iCAAA;EACA,eAAA;AAHJ;;AAOA;;EAEE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uFAAA;AAJF;;AAOA;EACE,wCAAA;EACA,gBAAA;EACA,2CAAA;AAJF;AAME;EACE,sCAAA;EACA,2CAAA;EACA,4CAAA;AAJJ;;AAQA;EACE,WAAA;EACA,sCAAA;EACA,4CAAA;EACA,6CAAA;AALF;AAOE;EACE,WAAA;EACA,2CAAA;EACA,6CAAA;AALJ;AAQE;EACE,mDAAA;EACA,mBAAA;AANJ;;AAUA;EACE,mBAAA;EACA,aAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,wCAAA;EACA,mBAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AAPF;AASE;EACE,wBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AAPJ;AAUE;EACE,gBAAA;EACA,SAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;AARJ;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,gCAAA;EACA,kBAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE;IACE,aAAA;IACA,cAAA;IACA,iBAAA;EATF;EAYA;IACE,uBAAA;IACA,eAAA;EAVF;EAaA;IACE,WAAA;IACA,mBAAA;EAXF;EAcA;IACE,qCAAA;IACA,YAAA;EAZF;EAeA;IACE,iBAAA;EAbF;EAgBA;IACE,oBAAA;IACA,sBAAA;EAdF;EAiBA;IACE,yBAAA;EAfF;AACF;AAkBA;EACE;IACE,sBAAA;IACA,qBAAA;EAhBF;EAmBA;IACE,aAAA;EAjBF;EAoBA;IACE,YAAA;EAlBF;EAqBA;IACE,WAAA;IACA,aAAA;EAnBF;EAsBA;IACE,oBAAA;EApBF;EAuBA;IACE,aAAA;EArBF;EAwBA;IACE,kBAAA;IACA,iBAAA;EAtBF;EAyBA;IACE,aAAA;IACA,gCAAA;EAvBF;EA0BA;IACE,WAAA;IACA,qBAAA;IACA,oBAAA;EAxBF;EA2BA;IACE,iBAAA;EAzBF;AACF;AA4BA;EACE;;;;IAIE,gBAAA;EA1BF;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.manual-asset-page {\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 1rem;\n  color: var(--ca-text-primary, #172033);\n}\n\n.page-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.25rem;\n  margin: 0.25rem 0 1.25rem;\n}\n\n.heading-copy {\n  min-width: 0;\n}\n\n.heading-copy h1 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.4rem, 2.2vw, 1.85rem);\n  font-weight: 750;\n  letter-spacing: -0.035em;\n}\n\n.eyebrow {\n  margin-bottom: 0.45rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n}\n\n.heading-copy > p {\n  max-width: 760px;\n  margin: 0.55rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n.heading-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n  flex: 0 0 auto;\n}\n\n.heading-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3.25rem;\n  height: 3.25rem;\n  color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  border: 1px solid rgba(40, 80, 173, 0.15);\n  border-radius: var(--ca-radius-lg, 12px);\n  font-size: 1.35rem;\n}\n\n.dialog-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.4rem;\n  height: 2.4rem;\n  padding: 0;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-sm, 6px);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-text-secondary, #4b5870);\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: var(--ca-border, #dfe4ec);\n    background: var(--ca-bg-secondary, #eef2f8);\n    color: var(--ca-text-primary, #172033);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--ca-primary-light, #2850ad);\n    outline-offset: 3px;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n\n.manual-asset-card {\n  overflow: hidden;\n  background: var(--ca-surface, #fff);\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));\n}\n\n.card-intro {\n  display: flex;\n  align-items: center;\n  gap: 0.9rem;\n  padding: 1.15rem clamp(1.1rem, 2.5vw, 2rem);\n  background: linear-gradient(180deg, #fbfcff 0%, #f7f9fd 100%);\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.card-intro-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.7rem;\n  height: 2.7rem;\n  flex: 0 0 2.7rem;\n  color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 1.1rem;\n}\n\n.card-intro-copy {\n  min-width: 0;\n}\n\n.card-intro h2 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.05rem;\n  font-weight: 750;\n}\n\n.card-intro p {\n  margin: 0.25rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.82rem;\n  line-height: 1.5;\n}\n\n.asset-id-reference {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  max-width: 100%;\n  margin-top: 0.45rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.72rem;\n  overflow-wrap: anywhere;\n}\n\n.required-note {\n  margin-left: auto;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.75rem;\n  white-space: nowrap;\n}\n\n.required-mark {\n  color: var(--ca-danger, #dc3545);\n  font-weight: 800;\n}\n\n.form-section {\n  padding: clamp(1.1rem, 2.4vw, 1.8rem);\n}\n\n.form-section + .form-section {\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.section-heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  margin-bottom: 1.25rem;\n}\n\n.section-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  flex: 0 0 2rem;\n  color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  border-radius: 0.55rem;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n.section-heading h3 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1rem;\n  font-weight: 750;\n}\n\n.section-heading p {\n  margin: 0.25rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.82rem;\n  line-height: 1.5;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.15rem 1.5rem;\n}\n\n.field-group {\n  min-width: 0;\n}\n\n.field-full {\n  grid-column: 1 / -1;\n}\n\n.field-group .form-label {\n  display: block;\n  margin-bottom: 0.45rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.82rem;\n  font-weight: 650;\n}\n\n.form-control,\n.form-select {\n  min-height: 42px;\n  border-color: var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-sm, 6px);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.875rem;\n  box-shadow: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n}\n\n.form-control:hover:not(:disabled):not([readonly]),\n.form-select:hover:not(:disabled):not([readonly]) {\n  border-color: var(--ca-border-dark, #c7cfdd);\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: var(--ca-primary-light, #2850ad);\n  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.13);\n}\n\n.form-control.is-invalid,\n.form-select.is-invalid {\n  border-color: var(--ca-danger, #dc3545);\n  background-image: none;\n}\n\n.description-input {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.monospace-input {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", monospace;\n  font-size: 0.8rem;\n}\n\n.field-hint {\n  display: block;\n  margin-top: 0.35rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.72rem;\n  line-height: 1.45;\n}\n\n.field-error {\n  display: block;\n  margin-top: 0.35rem;\n  color: var(--ca-danger, #dc3545);\n  font-size: 0.74rem;\n  line-height: 1.4;\n}\n\n.optional-label {\n  margin-left: 0.4rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.72rem;\n  font-weight: 500;\n}\n\n.form-error-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  margin: 0 clamp(1.1rem, 2.4vw, 1.8rem) 1rem;\n  padding: 0.85rem 1rem;\n  color: #842029;\n  background: var(--ca-danger-bg, #fdecef);\n  border: 1px solid var(--ca-danger, #dc3545);\n  border-radius: var(--ca-radius-sm, 6px);\n  font-size: 0.82rem;\n  line-height: 1.45;\n\n  i {\n    margin-top: 0.1rem;\n    flex: 0 0 auto;\n  }\n}\n\n.form-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.1rem clamp(1.1rem, 2.4vw, 1.8rem);\n  background: #fbfcfe;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.form-actions-note {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.75rem;\n  line-height: 1.4;\n\n  i {\n    flex: 0 0 auto;\n    color: var(--ca-success, #198754);\n    font-size: 1rem;\n  }\n}\n\n.action-buttons,\n.load-failure-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.7rem;\n  flex-shrink: 0;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n  padding: 0.55rem 1rem;\n  border-radius: var(--ca-radius-sm, 6px);\n  font-size: 0.82rem;\n  font-weight: 650;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.btn-cancel {\n  color: var(--ca-text-secondary, #4b5870);\n  background: #fff;\n  border: 1px solid var(--ca-border, #dfe4ec);\n\n  &:hover:not(:disabled) {\n    color: var(--ca-text-primary, #172033);\n    background: var(--ca-bg-secondary, #eef2f8);\n    border-color: var(--ca-border-dark, #c7cfdd);\n  }\n}\n\n.btn-save {\n  color: #fff;\n  background: var(--ca-primary, #0e2e80);\n  border: 1px solid var(--ca-primary, #0e2e80);\n  box-shadow: 0 2px 5px rgba(14, 46, 128, 0.12);\n\n  &:hover:not(:disabled) {\n    color: #fff;\n    background: var(--ca-primary-dark, #0d2863);\n    border-color: var(--ca-primary-dark, #0d2863);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--ca-primary-light, #2850ad);\n    outline-offset: 3px;\n  }\n}\n\n.btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.loading-panel {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  min-height: 280px;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.875rem;\n}\n\n.load-failure {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 260px;\n  padding: 2rem 1.25rem;\n  text-align: center;\n\n  h3 {\n    margin: 0.8rem 0 0.35rem;\n    color: var(--ca-text-primary, #172033);\n    font-size: 1rem;\n    font-weight: 750;\n  }\n\n  p {\n    max-width: 34rem;\n    margin: 0;\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.84rem;\n    line-height: 1.55;\n  }\n}\n\n.load-failure-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-danger, #dc3545);\n  font-size: 1.25rem;\n}\n\n.load-failure-actions {\n  margin-top: 1.25rem;\n}\n\n@media (max-width: 767.98px) {\n  .heading-mark {\n    width: 2.8rem;\n    height: 2.8rem;\n    font-size: 1.1rem;\n  }\n\n  .card-intro {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .required-note {\n    width: 100%;\n    margin-left: 3.6rem;\n  }\n\n  .form-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 1.05rem;\n  }\n\n  .field-full {\n    grid-column: auto;\n  }\n\n  .form-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .action-buttons {\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 480px) {\n  .manual-asset-page {\n    padding-right: 0.25rem;\n    padding-left: 0.25rem;\n  }\n\n  .heading-mark {\n    display: none;\n  }\n\n  .heading-actions {\n    gap: 0.25rem;\n  }\n\n  .card-intro {\n    gap: 0.7rem;\n    padding: 1rem;\n  }\n\n  .form-section {\n    padding: 1.1rem 1rem;\n  }\n\n  .form-actions {\n    padding: 1rem;\n  }\n\n  .form-error-banner {\n    margin-right: 1rem;\n    margin-left: 1rem;\n  }\n\n  .action-buttons {\n    display: grid;\n    grid-template-columns: 1fr 1.5fr;\n  }\n\n  .action-buttons .btn {\n    width: 100%;\n    padding-right: 0.6rem;\n    padding-left: 0.6rem;\n  }\n\n  .form-actions-note {\n    font-size: 0.7rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .dialog-close,\n  .form-control,\n  .form-select,\n  .btn {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
